export function removeNonDigitsCharacters(text = "") {
  return text.replace(/\D/g, "");
}
